import React, { useContext, useEffect, useState } from 'react';
import * as exifr from 'exifr';
import "./CreateProject/CreatProject.css";
import Application from '../../StateContext/Application';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages.js';
import { useLocation, useNavigate } from 'react-router-dom';

const UpdateGRDraft = () => {
    const nav = useNavigate();
    const urlLocation = useLocation();
    const id = urlLocation.state?.id;

    const operation = useContext(Application);
    const { GRCreation, GetBudgetHeadInfo, EditDraftCopy } = operation;

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);


    const [data, setData] = useState({
        GRID: id,
        HeadCode: "",
        ProposalYear: "",
        ZillaParishad: "",
        GRNumber: "",
        GRDate: "",
        GRAmount: ""
    });

    const FetchedIntitialData = async () => {
        setLoading(true);
        try {
            let res = await GetBudgetHeadInfo(id, "GetSpecificGRCreationInfoBYGRID");
            console.log("Data i get from Bakcend :: ", res);
            let GRCreationInfo = res[0];

            const { HeadCode, ProposalYear, ZillaParishad, GRAmount, GRNumber, GRDate } = GRCreationInfo;

            const rawDate = GRCreationInfo.GRDate;
            const formattedGRDate = rawDate
                ? new Date(rawDate).toISOString().slice(0, 16)
                : "";

            setData({
                ...data,
                HeadCode: HeadCode,
                ProposalYear: ProposalYear,
                ZillaParishad: ZillaParishad,
                GRNumber: GRNumber,
                GRDate: formattedGRDate,
                GRAmount: GRAmount
            });
        }
        catch (err) {
            console.log(err);
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        FetchedIntitialData();
    }, [id]);


    const processFile = (file) => {
        return new Promise(async (resolve, reject) => {
            try {
                const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
                const pdfTypes = ["application/pdf"];
                const excelTypes = [
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "text/csv"
                ];

                // ===== IMAGE FILE =====
                if (imageTypes.includes(file.type)) {
                    const exifData = await exifr.parse(file, ['GPSLatitude', 'GPSLongitude']);
                    if (exifData && (exifData.GPSLatitude || exifData.GPSLongitude)) {
                        console.warn(`⚠️ EXIF GPS data found in ${file.name}. It will be stripped.`);
                    }

                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.onload = () => {
                            const canvas = document.createElement("canvas");
                            canvas.width = img.width;
                            canvas.height = img.height;
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(img, 0, 0);

                            canvas.toBlob((blob) => {
                                const cleanedFile = new File([blob], file.name, { type: file.type });
                                resolve(cleanedFile);
                            }, file.type);
                        };
                        img.onerror = reject;
                        img.src = e.target.result;
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                    return;
                }

                // ===== PDF FILE =====
                if (pdfTypes.includes(file.type)) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const text = e.target.result;

                        const badPatterns = ["/JS", "/JavaScript", "/AA", "/OpenAction", "/Launch", "/RichMedia"];
                        const isMalicious = badPatterns.some(p => text.includes(p));

                        if (isMalicious) {
                            alert(`⚠️ Suspicious PDF detected in file "${file.name}". The page will reload.`);
                            window.location.reload(); // reload page
                            return reject(new Error("Malicious PDF detected"));
                        }

                        resolve(file); // safe PDF
                    };
                    reader.onerror = reject;
                    reader.readAsText(file);
                    return;
                }


                // ======= Excel File ======

                if (excelTypes.includes(file.type)) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const text = e.target.result;

                        const badPatterns = [
                            "vbaProject.bin",
                            "script",
                            "javascript:",
                            "xml version",
                            "ActiveXObject",
                            "onerror=", "onload=", "onclick="
                        ];
                        const isMalicious = badPatterns.some(p =>
                            text.toLowerCase().includes(p.toLowerCase())
                        );

                        if (isMalicious) {
                            alert(`⚠️ Suspicious Excel file detected: "${file.name}". The page will reload.`);
                            window.location.reload();
                            return reject(new Error("Malicious Excel content detected"));
                        }

                        resolve(file);
                    };
                    reader.onerror = reject;

                    if (file.type === "text/csv") {
                        reader.readAsText(file);
                    } else {
                        reader.readAsBinaryString(file);
                    }
                    return;
                }

                // ===== OTHER FILE TYPES =====
                resolve(file);

            } catch (error) {
                console.error("Error processing file:", error);
                reject(error);
            }
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        let shouldSubmit = window.confirm("Are you Sure ??");
        if (shouldSubmit) {
            const formData = new FormData();
            try {

                let GRDraftCopy = document.getElementById("GRDraftCopy").files;
                if (GRDraftCopy.length <= 0) {
                    alert("GR Approval Copy is Missing !!")
                    return;
                }


                // formData.append("GROriginalDraftCopy", GRDraftCopy[0]);
                formData.append("file", GRDraftCopy[0]);

                for (const key in data) {
                    let value = data[key];
                    formData.append(key, value);
                }

                formData.append("ActionType", "UpdateGRDraft");
                let result = await EditDraftCopy(formData);


                const { status, message } = result;

                if (status) {
                    alert(message);
                    nav(-1);
                }
                else {
                    alert(message);
                    setLoading(false);
                }
            } catch (err) {
                console.log(err);
                alert("Error while Updating Proposal !!!");
                setLoading(false);
            } finally {
                setLoading(false);
            }
        }
        else {
            alert("GR Draft Upload Operation Cancel !!!");
            setLoading(false);
        }


    };

 const handleFileUpload = (e) => {

        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
        ];

        if (!allowedTypes.includes(file.type)) {
            alert("Only PDF, JPG , JPEG, PNG files are allowed");
            e.target.value = ""; // Reset input
            return;
        }
        const cleanedFileName = file.name
            .trim()
            .replace(/\s+/g, "");
        console.log("cln file", cleanedFileName.lastModified)
        return new File([file], cleanedFileName, {
            type: file.type,
            lastModified: file.lastModified,
        });

    };
    return (
        <>

            <div style={{ backgroundColor: "#EFF3F8", height: '90vh', overflowY: 'auto' }}>
                <div className="col-12" style={{ padding: '2rem 0px 5px 0px', overflowX: "hidden" }}>
                    <div className="col-12 m-auto my-5 budgetContainer">
                        <div className="m-auto budgetElement">

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                                <div>
                                    <h5 className=' bg-light'><img src={ProposalCreation32} /> Update GR Draft</h5>
                                </div>
                                <div>
                                    <div>
                                        <img src={Back32} onClick={() => nav(-1)} />
                                    </div>
                                </div>
                            </div>


                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                                    }}>
                                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                    <style>
                                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                    </style>
                                </div>
                            )}



                            <div className="budgetElement2">
                                <form action="">
                                    <div className="col-11 mx-auto">

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>HeadCode</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" className='form-control py-2'
                                                        value={data.HeadCode} disabled />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>GR Number <span className='text-danger fw-bold'>*</span></label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="text" placeholder='Enter GR Number' className='form-control py-2' name='GRNumber'
                                                        value={data.GRNumber}
                                                        disabled />
                                                </div>
                                            </div>
                                        </div>



                                        <div className="col-12 elements">
                                            <div className="row">
                                                <div className="col-5">
                                                    <label>GR Approval Copy</label>
                                                </div>
                                                <div className="col-7">
                                                    <input type="file" className='form-control py-2' id='GRDraftCopy' accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileUpload} />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-12 ms-auto my-4">
                                            <div className="row">
                                                <div className="col-3"></div>
                                                <div className="col-8">
                                                    <div className="col-12" style={{ display: 'flex', gap: '10px' }}>

                                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '10rem', height: '2rem', fontSize: '18px' }} onClick={(e) => { handleSubmit(e, "Submitted") }}><img src={submit} style={{ width: '13px' }} />Submit Draft</button>
                                                        <button
                                                            type="button"
                                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1094c', width: '6rem', height: '2rem', fontSize: '16px' }}
                                                            onClick={() => {
                                                                document.getElementById("GRDraftCopy").value = "";
                                                            }}
                                                        ><img src={Cancel32} style={{ width: '17px' }} /> Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </form>
                            </div>



                        </div>



                    </div>
                </div>
            </div>


        </>
    )
}

export default UpdateGRDraft;